import { j as jsxRuntimeExports } from './jsx-runtime-D2XkDcqR.js';

const PostHogTracking = ({ id, ...config }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
  id ? /* @__PURE__ */ jsxRuntimeExports.jsx("script", { async: true, src: getScriptSrc() }) : null,
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "script",
    {
      dangerouslySetInnerHTML: {
        __html: getScriptInit(id, config)
      }
    }
  )
] });
const getScriptSrc = () => "https://us-assets.i.posthog.com/static/array.js";
const getScriptInit = (id, config) => [
  `window.posthog=[]`,
  `posthog._i=[]`,
  `posthog.__SV=1`,
  `posthog.people=[]`,
  `posthog.toString=e=>e?"posthog":"posthog (stub)"`,
  `posthog.people.toString=()=>posthog.toString(!0)+".people (stub)"`,
  `posthog.init=(e,t)=>{const o=(e,t)=>{const o=t.split(".");2===o.length&&(e=e[o[0]],t=o[1]),e[t]=(...o)=>{e.push([t,...o])}},s=["init","capture","register","register_once","register_for_session","unregister","unregister_for_session","getFeatureFlag","getFeatureFlagPayload","isFeatureEnabled","reloadFeatureFlags","updateEarlyAccessFeatureEnrollment","getEarlyAccessFeatures","on","onFeatureFlags","onSessionId","getSurveys","getActiveMatchingSurveys","renderSurvey","canRenderSurvey","getNextSurveyStep","identify","setPersonProperties","group","resetGroups","setPersonPropertiesForFlags","resetPersonPropertiesForFlags","setGroupPropertiesForFlags","resetGroupPropertiesForFlags","reset","get_distinct_id","getGroups","get_session_id","get_session_replay_url","alias","set_config","startSessionRecording","stopSessionRecording","sessionRecordingStarted","captureException","loadToolbar","get_property","getSessionProperty","createPersonProfile","opt_in_capturing","opt_out_capturing","has_opted_in_capturing","has_opted_out_capturing","clear_opt_in_out_capturing","debug"];for(const e of s)o(posthog,e);posthog._i.push([e,t,"posthog"])},posthog.init("phc_FlBRVC8QUBDr2ezMq5x51NwSndDwUkRNRs2G4ru502U",{api_host:"https://us.i.posthog.com",person_profiles:"identified_only"})`,
  `posthog.init(${JSON.stringify(id)},${JSON.stringify(config)})`
].join(";");

export { PostHogTracking };
